<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="算税单号、名称"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态/单号"
          prop="status"
          sortable="status"
          width="120"
          fixed="left"
        >
          <template #default="{ row }">
            <c_tabgroup :value2="row.calc_tax_order_id">
              <template #top>
                <div style="display: flex; align-items: center">
                  <c_status arrName="calctax_status" :value="row.status" />
                  <el-popover
                    v-if="row.tax_failure_msg"
                    placement="right"
                    trigger="hover"
                  >
                    <template #reference>
                      <el-icon
                        color="#ffa500"
                        style="margin-left: 5px; cursor: pointer"
                        ><QuestionFilled
                      /></el-icon>
                    </template>
                    <template #default>
                      <text
                        style="
                          font-size: 13px;
                          line-height: 22px;
                          color: #ffa500;
                          letter-spacing: 2px;
                        "
                        >{{ row.tax_failure_msg }}</text
                      >
                    </template>
                  </el-popover>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          prop="calc_tax_name"
          label="名称"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="customer_name"
          label="所属客户"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="扣缴义务人/税局">
          <template #default="{ row }">
            <c_tabgroup :value2="row.tax_bureau_name">
              <template #top>
                <div
                  v-if="row.withholding_agent_id"
                  :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
                  :style="{
                    '--dynamic-color':
                      row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
                  }"
                  class="withholding-badge"
                  :title="row.withholding_agent_name"
                >
                  {{ row.withholding_agent_name }}
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          prop="tax_month"
          label="税款所属期"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="taxable_income"
          label="应税金额"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          prop="tax_money"
          label="税额"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          prop="add_admin_name"
          label="算税人"
          :formatter="$tab_TextFormat"
        />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { employee_calctax } from "@/http/employee";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  props: {
    employee_id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.employee_id = props.employee_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      employee_calctax(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      props,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style scoped></style>
